<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">
                Learn about damage to buildings
              </div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                General information about different kinds of damage
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container class=" white-background">
        <v-layout column wrap class="" align-center>
          <v-flex xs12 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline pa-2">Damage from Tropical Cyclones</h2>
              <span class="subheading pa-2"> General Information</span>
            </div>
            <div>
              <p class="pa-2">
                Tropical cyclones can produce very strong and potentially
                destructive winds and storm tides over large areas that can last
                several hours. The<a class="pl-1 pr-1"
                  href="http://www.bom.gov.au/cyclone/?ref=ftr"
                  >Bureau of Meteorology</a
                >has some excellent information on cyclones that explain how
                they are formed, the wind speeds expected and information on
                storm tides generated during tropical cyclones that may affect
                properties close to the coast.
              </p>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xs xs12>
              <v-layout row wrap xs12>
                <v-card class="ma-2" xs6>
                  <v-img
                    :src="require('@/assets/wind.jpg')"
                    aspect-ratio="1"
                    width="300px"
                  ></v-img>

                  <v-card-title primary-title>
                    <div style=" width: 250px">
                      <h3 class="headline mb-0">Wind Damage</h3>
                      <p class="subtitle-1" >
                        All parts of the building must work together to resist
                        the extremely high wind forces generated during tropical
                        cyclones.
                      </p>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn text color="primary" @click="gotoWind"
                      >Learn More</v-btn
                    >
                  </v-card-actions>
                </v-card>
                <v-card class="ma-2" xs6>
                  <v-img
                    :src="require('@/assets/wind-driven-rain.jpg')"
                    aspect-ratio="1"
                    width="300px"
                  ></v-img>

                  <v-card-title primary-title>
                    <div style=" width: 250px">
                      <h3 class="headline mb-0">Wind Driven Rain</h3>
                      <p class="subtitle-1" >
                        Significant amounts of wind-driven rain can enter
                        buildings, even during cyclones with winds significantly
                        less than the design wind speed.
                      </p>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn text color="primary" @click="gotoRain"
                      >Learn More</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-layout>
              <v-layout row wrap>
                <v-card class="ma-2" xs6>
                  <v-img
                    :src="require('@/assets/surge.jpg')"
                    aspect-ratio="1"
                    width="300px"
                  ></v-img>

                  <v-card-title primary-title>
                    <div style=" width: 250px">
                      <h3 class="headline mb-0">Storm Surge</h3>
                      <p class="subtitle-1">
                        If the elevated sea level is higher than the lower floor
                        level, the building will have seawater flowing through
                        it.
                      </p>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn text color="primary" @click="gotoStorm"
                      >Learn More</v-btn
                    >
                  </v-card-actions>
                </v-card>
                <v-card class="ma-2" xs6>
                  <v-img
                    :src="require('@/assets/ancillary.jpg')"
                    aspect-ratio="1"
                    width="300px"
                  ></v-img>

                  <v-card-title primary-title>
                    <div style=" width: 250px">
                      <h3 class="headline mb-0">Ancillary Items</h3>
                      <p class="subtitle-1" >
                        Items in the grounds of properties are vulnerable to
                        damage from wind forces and wind-borne debris.
                      </p>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn text color="primary" @click="gotoAncillary"
                      >Learn More</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <Footer></Footer>
  </v-content>
</template>

<style>

  .v-card__text, .v-card__title {
    word-break: normal; /* maybe !important  */
  }
</style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import { router } from "../router";

export default {
  name: "Damage",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    size: "sm"
  }),
  methods: {
    gotoWind() {
      router.push("/wind");
    },
    gotoRain() {
      router.push("/rain");
    },
    gotoStorm() {
      router.push("/storm");
    },
    gotoAncillary() {
      router.push("/ancillary");
    }
  }
};
</script>
